// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V22H2V2ZM12 18.25L16 12H13V6H11V12L8 12L12 18.25Z"}}]};

const ArrowDownRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-down-rectangle-filled',
    ref,
    icon: element,
  },
));

ArrowDownRectangleFilledIcon.displayName = 'ArrowDownRectangleFilledIcon';

export default ArrowDownRectangleFilledIcon;
